export interface NavItem {
  id: string;
  label: string;
}

export interface QuickFact {
  label: string;
  value: string;
}

export interface TimelineStep {
  index: string;
  title: string;
  text: string;
}

export interface BackgroundCard {
  icon: string;
  title: string;
  text: string;
}

export interface EndingTab {
  key: string;
  label: string;
  headline: string;
  paragraphs: string[];
  points: string[];
}

export interface RelationPair {
  a: string;
  b: string;
  tag: string;
  text: string;
}

export interface CharacterItem {
  id: string;
  name: string;
  role: string;
  category: string;
  avatar: string;
  tags: string[];
  summary: string;
  traits: string[];
  arc: string;
}

export interface StorySegment {
  id: string;
  stage: string;
  title: string;
  paragraphs: string[];
}

export interface SceneItem {
  no: string;
  title: string;
  text: string;
}

export interface ThemeItem {
  icon: string;
  title: string;
  text: string;
}

export interface FaqItem {
  q: string;
  a: string;
}

export interface InfoRow {
  label: string;
  value: string;
}

export const siteName = "善良的嫂子";

export const heroChips = [
  "家庭伦理",
  "心理剧情",
  "结局解析",
  "人物关系",
  "剧情梳理",
];

export const navItems: NavItem[] = [
  { id: "overview", label: "剧情梗概" },
  { id: "ending", label: "结局解析" },
  { id: "relations", label: "人物关系" },
  { id: "characters", label: "角色介绍" },
  { id: "story", label: "剧情梳理" },
  { id: "scenes", label: "关键看点" },
  { id: "faq", label: "常见疑问" },
];

export const quickFacts: QuickFact[] = [
  { label: "作品类型", value: "家庭伦理 / 心理剧情" },
  { label: "核心悬念", value: "一段忽然冷却的婚姻" },
  { label: "叙事视角", value: "以人物内心与关系张力为主" },
  { label: "结局气质", value: "克制收束 · 留白解读" },
];

export const overviewPoints: BackgroundCard[] = [
  {
    icon: "ri-home-heart-line",
    title: "关系设定",
    text: "故事围绕一个家庭内部的三个人展开：一位以倾听与疏导为职业的姐姐、一位被婚姻冷落而困惑的妹妹，以及态度逐渐疏远的丈夫。三人本是彼此最亲近的人，却各自守着一部分不肯说出口的心事。",
  },
  {
    icon: "ri-emotion-unhappy-line",
    title: "冲突起点",
    text: "矛盾并不来自激烈的争吵，而是从日常里一点点的沉默开始发酵。妹妹察觉到丈夫态度的变化，试图寻找原因，却始终得不到想要的答案，于是把希望寄托在更理性的家人身上。",
  },
  {
    icon: "ri-user-voice-line",
    title: "求助与介入",
    text: "当姐姐以专业身份介入这段关系时，原本属于私人的情感困局被摊开到更复杂的层面：一边是亲情与信任，一边是职业的边界，任何一步走得近一点，都可能打破原有的平衡。",
  },
  {
    icon: "ri-eye-off-line",
    title: "核心看点",
    text: "真正推动故事的不是外部的戏剧冲突，而是人物面对真实心意时的迟疑与克制。影片把镜头对准那些「说不出口」的瞬间，让观众自己去判断：究竟谁在隐忍，谁在赎罪。",
  },
];

export const timelineSteps: TimelineStep[] = [
  {
    index: "01",
    title: "平静的表象",
    text: "生活看起来一如既往，日常的相处却已经悄悄生出缝隙。人物的客气与礼貌，反而成了距离感的证明。",
  },
  {
    index: "02",
    title: "裂缝被察觉",
    text: "妹妹感到婚姻的温度在下降，她一开始以为只是暂时的疲惫，直到不安变成反复出现的疑问。",
  },
  {
    index: "03",
    title: "求助与靠近",
    text: "她向最信任的姐姐求助。姐姐出于善意介入，试图用理性去梳理这段关系里说不清的部分。",
  },
  {
    index: "04",
    title: "真相逼近",
    text: "梳理的过程中，被掩藏的心事逐渐浮现。原本只想解决婚姻问题的人，开始被迫面对自己也在其中。",
  },
  {
    index: "05",
    title: "各自面对",
    text: "没有轰轰烈烈的摊牌，只有情感与理智拉扯之后的选择。每个人都回到自己的位置上，带着新的沉默。",
  },
];

export const endingTabs: EndingTab[] = [
  {
    key: "main",
    label: "主线结局",
    headline: "克制收束，而非激烈审判",
    paragraphs: [
      "《善良的嫂子》的结局并没有走向观众熟悉的狗血对峙：没有一场把所有人聚在一起的争吵，也没有一个明确的「谁对谁错」的宣判。影片选择了收着拍——把最激烈的东西留在镜头之外，让观众自己去补全。",
      "在接近尾声的部分，故事的重心从「发生了什么」转向「如何面对」。人物开始接受一个事实：有些情感的裂痕无法被彻底修补，有些话说出口反而会造成更大的伤害。于是他们选择用克制去替代摊牌。",
      "这种克制并不是回避，而是一种更高难度的表达。它让结局同时具备了「尘埃落定」和「意犹未尽」两种感觉——事情看似结束了，但每个人心里都还留着没有完成的对话。",
    ],
    points: [
      "结局以人物的心理落点收束，而非以大事件收束",
      "没有绝对的赢家和输家，也没有单一的道德结论",
      "留白是刻意设计，让解读权交回给观众",
    ],
  },
  {
    key: "fate",
    label: "人物归宿",
    headline: "每个人都回到了自己的位置",
    paragraphs: [
      "结局里，三个人都没有真正「离开」自己的身份。身为姐姐的人重新把注意力放回专业与家庭边界上，她最擅长的理性和倾听，最终用在了自己身上。",
      "妹妹的走向偏向「重新审视」。她未必得到了想要的答案，但开始明白，婚姻里的疏远有时并不是某个具体事件造成的，而是两个人长期没有好好说话累积的结果。",
      "丈夫的归宿则是「面对」。他不再用沉默来回避，却也没有用表白去索取。他接受了自己造成的距离，并为此承担了相应的人际代价——这本身就是故事给出的答案之一。",
    ],
    points: [
      "姐姐：回归理性与边界，把秘密留在心里",
      "妹妹：带着疑问重新理解婚姻，而非撕裂收场",
      "丈夫：承认疏远，接受关系降温的后果",
    ],
  },
  {
    key: "open",
    label: "开放式解读",
    headline: "三种都能成立的读法",
    paragraphs: [
      "读法一：救赎。人物的克制被理解为一种成长——他们终于学会为别人考虑，把冲动挡在了伤害发生之前。结局是一次艰难但正确止步。",
      "读法二：妥协。另一种看法认为，结局里没有真正的和解，只有把问题重新压回日常。表面恢复了平静，实际上谁也没有得到解脱。",
      "读法三：循环。还有观众认为，故事展示的是一种反复出现的关系模式——问题被搁置，然后在下一个家庭、下一段关系里重演。片尾的平静，更像是下一轮沉默的开始。",
      "哪种读法更接近创作者的意图，影片本身并未给出标准答案。这正是它讨论度高的原因：留白让人愿意反复回想那些没有台词的镜头。",
    ],
    points: [
      "救赎说：克制是一种成长与成全",
      "妥协说：平静只是问题的暂时搁置",
      "循环说：关系模式可能在别处重演",
    ],
  },
];

export const relationPairs: RelationPair[] = [
  {
    a: "河英",
    b: "河周",
    tag: "姐妹",
    text: "彼此信赖，是对方最愿意倾诉的人。正因亲密，姐姐的介入既能带来安慰，也可能在不经意间加重妹妹的依赖与困惑。",
  },
  {
    a: "河周",
    b: "宇成",
    tag: "夫妻",
    text: "关系由长期累积的沉默构成。距离并非某天突然出现，而是在一次次「没说出口」里被慢慢拉大，成为整段故事最核心的裂缝。",
  },
  {
    a: "河英",
    b: "宇成",
    tag: "家人 / 疏导者",
    text: "本应是清晰的家人与求助关系，却因为要处理最私密的情感而变得微妙。专业距离与家庭情感在这里互相拉扯，成为故事张力的来源。",
  },
  {
    a: "三人之间",
    b: "整体关系",
    tag: "张力闭环",
    text: "三个人的关系彼此牵动：一方的靠近会牵动另一方的不安，一方的沉默又会放大第三方的猜测。正是这种相互牵制，构成了全片的心理张力。",
  },
];

export const characters: CharacterItem[] = [
  {
    id: "haying",
    name: "河英",
    role: "姐姐 · 心理学专业人士",
    category: "主要角色",
    avatar:
      "https://readdy.ai/api/search-image?query=silhouette%20of%20an%20elegant%20woman%20standing%20by%20a%20tall%20window%20with%20soft%20warm%20backlight%2C%20cinematic%20moody%20atmosphere%2C%20muted%20terracotta%20and%20amber%20tones%2C%20artistic%20blurred%20interior%2C%20no%20visible%20face%2C%20thoughtful%20calm%20mood&width=800&height=1000&seq=ssl-char-haying&orientation=portrait",
    tags: ["理性", "克制", "倾听者"],
    summary:
      "习惯用理性分析他人的情绪，也因此更容易忽略自己的感受。她的专业让她能看清别人的困境，却不一定能替自己做出最简单的选择。",
    traits: ["擅长克制与倾听", "重视家庭责任", "习惯把情绪藏起来"],
    arc: "从「替别人解决问题」到「面对自己也在其中」，她学会了给关系划出边界。",
  },
  {
    id: "hazhou",
    name: "河周",
    role: "妹妹 · 婚姻中的困惑者",
    category: "主要角色",
    avatar:
      "https://readdy.ai/api/search-image?query=silhouette%20of%20a%20young%20woman%20sitting%20alone%20in%20a%20softly%20lit%20room%20at%20dusk%2C%20warm%20amber%20light%20through%20curtains%2C%20cinematic%20melancholy%2C%20muted%20earth%20tones%2C%20artistic%20and%20slightly%20blurred%2C%20introspective%20quiet%20mood&width=800&height=1000&seq=ssl-char-hazhou&orientation=portrait",
    tags: ["敏感", "渴望理解", "脆弱"],
    summary:
      "她敏锐地察觉到关系的变化，却缺少一个能确认答案的出口。她的困惑不是无理取闹，而是长期得不到回应之后的自然反应。",
    traits: ["感受细腻", "需要被回应", "容易陷入自我怀疑"],
    arc: "从「一定要问出原因」到「理解有些疏远没有单一原因」，她开始重新看待婚姻。",
  },
  {
    id: "wosung",
    name: "宇成",
    role: "丈夫 · 沉默的当事人",
    category: "主要角色",
    avatar:
      "https://readdy.ai/api/search-image?query=silhouette%20of%20a%20man%20in%20profile%20against%20a%20warm%20dimly%20lit%20wall%2C%20cinematic%20deep%20shadows%2C%20muted%20brown%20and%20golden%20tones%2C%20artistic%20contemplative%20mood%2C%20no%20visible%20face%2C%20quiet%20restrained%20atmosphere&width=800&height=1000&seq=ssl-char-wosung&orientation=portrait",
    tags: ["压抑", "疏离", "矛盾"],
    summary:
      "用沉默来应对所有说不清的情绪，也因此把身边的人越推越远。他的冷淡并非无情，而更像是一种不会表达的笨拙。",
    traits: ["不善表达", "习惯回避", "内心矛盾重重"],
    arc: "从「用疏远解决问题」到「承认疏远本身才是问题」，他终于选择面对而不是逃开。",
  },
  {
    id: "relatives",
    name: "家庭亲友",
    role: "功能性角色 · 关系背景",
    category: "功能性角色",
    avatar:
      "https://readdy.ai/api/search-image?query=abstract%20warm%20interior%20scene%20of%20an%20empty%20family%20dining%20table%20with%20soft%20evening%20lamp%20light%2C%20muted%20amber%20and%20cream%20tones%2C%20cinematic%20artistic%20still%20life%2C%20gentle%20nostalgic%20atmosphere%2C%20no%20people&width=800&height=1000&seq=ssl-char-relatives&orientation=portrait",
    tags: ["旁观者", "氛围", "压力来源"],
    summary:
      "在以家庭为核心的故事里，亲友的存在往往代表着「别人的眼光」。他们的关心有时是温暖，有时也是一种无形的压力。",
    traits: ["维系家庭场域", "放大关系张力", "代表旁观视角"],
    arc: "主要用于照见主角在家庭期待与个人感受之间的两难。",
  },
  {
    id: "clinic",
    name: "诊疗空间",
    role: "功能性角色 · 象征场景",
    category: "功能性角色",
    avatar:
      "https://readdy.ai/api/search-image?query=quiet%20minimalist%20consulting%20room%20with%20a%20single%20armchair%20and%20soft%20warm%20window%20light%2C%20calm%20neutral%20cream%20and%20brown%20palette%2C%20cinematic%20artistic%20empty%20interior%2C%20peaceful%20intimate%20atmosphere%2C%20no%20people&width=800&height=1000&seq=ssl-char-clinic&orientation=portrait",
    tags: ["私密空间", "叙事支点", "象征"],
    summary:
      "那些最接近真相的对话，大多发生在一个安静、封闭的空间里。它既是故事推进的地点，也象征着「只有在这里才说得出口」的内心角落。",
    traits: ["承载关键对话", "安静而私密", "放大内心独白"],
    arc: "作为叙事的核心舞台，它让观众得以窥见人物不愿示人的一面。",
  },
];

export const characterFilters = ["全部", "主要角色", "功能性角色"];

export const storySegments: StorySegment[] = [
  {
    id: "segment-1",
    stage: "序幕",
    title: "平静的裂缝",
    paragraphs: [
      "故事从一个看起来再普通不过的家庭日常切入。没有铺垫式的交代，而是让人物直接进入他们早已习惯的相处方式：客气的问候、简短的对话、各自忙碌的节奏。",
      "正是这种「没什么不对，却也说不上哪里对」的氛围，为整部作品定下了基调。观众会先感到一种说不清的别扭，随后才慢慢意识到，那是关系里被长期忽略的沉默在发酵。",
    ],
  },
  {
    id: "segment-2",
    stage: "展开",
    title: "求助与介入",
    paragraphs: [
      "当妹妹感到婚姻的温度正在下降，她本能地寻找一个可以依靠的人。于是有着专业背景的姐姐成了这段关系之外的第一个知情人。",
      "姐姐最初只是想帮忙梳理问题，她相信只要把情绪讲清楚，事情就能回到正轨。但情感从来不是一道可以被理性彻底解开的题，她的介入，反而让三个人之间原本稳定的距离开始变化。",
    ],
  },
  {
    id: "segment-3",
    stage: "转折",
    title: "被掩藏的心事浮现",
    paragraphs: [
      "随着沟通的深入，原本只想解决婚姻问题的人，逐渐撞上了更复杂的部分。那些一直没有说出口的念头，在一次次谈话里被逼到明面上。",
      "这里的转折并不靠一个惊天秘密，而是靠人物态度的细微变化：一个眼神的躲闪、一句没说完的话、一次刻意的转身。影片用这些细节告诉观众，真正的问题从来不在表面。",
    ],
  },
  {
    id: "segment-4",
    stage: "收束",
    title: "各自面对，各自沉默",
    paragraphs: [
      "故事的后半段放慢了节奏，把更多空间留给人物独处。激烈已经被消化成内心的拉扯，每个人都必须在「说」与「不说」之间做出选择。",
      "最终，谁也没有得到完美的答案。他们只是各自回到自己的位置上，带着新的理解和新的沉默继续生活。这样的结局不热闹，却足够真实。",
    ],
  },
];

export const scenes: SceneItem[] = [
  {
    no: "01",
    title: "那顿安静的晚饭",
    text: "一家人围坐却几乎没有对话，碗筷的声音被刻意放大。这个日常场景精准地呈现了「同处一室，却隔着距离」的关系状态。",
  },
  {
    no: "02",
    title: "第一次说不出口的求助",
    text: "妹妹鼓起勇气想开口，话到嘴边又咽了回去。一个欲言又止的停顿，胜过许多解释，也让观众瞬间理解了她处境的尴尬。",
  },
  {
    no: "03",
    title: "诊疗室里最坦诚的一次对话",
    text: "封闭、安静的空间反而让人卸下防备。这是全片信息量最集中的段落之一，许多关键的态度就是在这里被第一次说清。",
  },
  {
    no: "04",
    title: "雨夜里的独白",
    text: "外部环境的变化映照着人物内心的起伏。没有台词的长镜头里，情绪的转折被压缩成几个动作和一段沉默。",
  },
  {
    no: "05",
    title: "临别前的一次对视",
    text: "既没有拥抱也没有争吵，只是一个短短的对视。它承载了整部作品想说又没说出口的一切，是结局氛围的关键注脚。",
  },
  {
    no: "06",
    title: "回到日常的清晨",
    text: "故事收在一段普通的晨间生活里。一切看似恢复原样，但读过全片的人会明白，平静的表面下已经起了变化。",
  },
];

export const themes: ThemeItem[] = [
  {
    icon: "ri-shield-check-line",
    title: "边界与克制",
    text: "最难的从来不是靠近，而是在该停下的地方停下来。影片反复在问：善意的介入，界限究竟在哪里。",
  },
  {
    icon: "ri-links-line",
    title: "亲密与疏离",
    text: "越是亲近的人，越容易把真实的感受藏起来。作品展示了亲密关系中那条看不见却真实存在的距离。",
  },
  {
    icon: "ri-scales-3-line",
    title: "理性与情感",
    text: "用理性分析情感，是有效的方法，也是一种逃避。二者的拉扯贯穿全片，也指向了结局的留白。",
  },
  {
    icon: "ri-chat-off-line",
    title: "沉默的沟通",
    text: "片中大量情绪由沉默承担。没有说出口的话，往往比说出来的更重，这也是故事最擅长表达的部分。",
  },
  {
    icon: "ri-heart-3-line",
    title: "善意的代价",
    text: "出发点善良，不代表结果一定温柔。影片没有把善意简单美化，而是追问它可能带来的连锁反应。",
  },
  {
    icon: "ri-eye-line",
    title: "观看的伦理",
    text: "故事把判断权交给观众：我们究竟是在理解人物，还是在替人物做道德审判？这也是开放式结局的深意所在。",
  },
];

export const faqs: FaqItem[] = [
  {
    q: "《善良的嫂子》的结局到底是开放式的，还是明确的？",
    a: "更接近「克制收束 + 留白解读」。故事并没有用一个明确的事件把一切画上句号，而是把重心放在人物的态度与选择上。它给了足够的线索让你判断走向，但刻意不给唯一的结论。这也是讨论度高的核心原因。",
  },
  {
    q: "河英和宇成之间到底是什么关系？",
    a: "从家庭关系上看，他们是因为婚姻而被联系起来的家人；从故事功能上看，又叠加了「求助者与疏导者」的关系。这种双重身份让他们的每一次互动都带着分寸感上的紧张——既要处理最私密的情感，又要守住家庭与职业的边界。",
  },
  {
    q: "为什么作品会用「善良」来命名？",
    a: "「善良」在这里更像是一个被反复检验的词。影片没有把善良当作褒义标签直接贴给谁，而是追问：当一个人怀着好意去介入别人的关系时，善意会不会也成为压力的一部分。标题本身，就带着这种反思意味。",
  },
  {
    q: "河周最后的态度说明了什么？",
    a: "她并没有得到那个「为什么」的标准答案，但她开始理解：有些疏远不是单一事件造成的，而是长期缺少沟通累积的结果。她最后的态度更偏向重新审视，而不是撕裂收场——这是一次冷静下来的停顿。",
  },
  {
    q: "这部作品适合什么样的观众？",
    a: "它更适合喜欢人物心理刻画、愿意在看完之后慢慢回味与讨论的观众。如果你期待的是快节奏的情节反转或激烈的对抗，可能会觉得它节奏偏慢；但如果你喜欢关系张力和留白，它会给你很多可以细品的空间。",
  },
  {
    q: "看到中间觉得节奏慢，需要坚持看完吗？",
    a: "建议看到后半段。作品把大量信息压在人物的态度变化和沉默里，第二遍回看时那些当时觉得「什么都没发生」的镜头，会突然变得有意义。结局的氛围也正是建立在这些铺垫之上。",
  },
];

export const seriesTitle = "同系列作品与延伸";

export const infoRows: InfoRow[] = [
  { label: "作品名称", value: "善良的嫂子" },
  { label: "题材类型", value: "家庭伦理 / 心理剧情" },
  { label: "叙事风格", value: "克制含蓄 · 注重人物内心" },
  { label: "结局类型", value: "开放式走向 · 留白收束" },
  { label: "适合人群", value: "偏好关系张力与心理刻画的观众" },
  { label: "观看建议", value: "建议完整观看，留意细节与沉默镜头" },
];

export const relatedNotes = [
  "同类型作品常围绕「家庭内部的隐秘张力」展开，重点往往不在事件本身，而在人物如何面对自己的选择。",
  "如果你喜欢本片对沉默与留白的处理，可以留意同样注重氛围与心理描写的家庭伦理题材影片。",
  "系列作品之间通常共享相似的叙事气质，但人物与故事彼此独立，可以分别观看。",
];

export const footerLinks: NavItem[] = [
  { id: "overview", label: "剧情梗概" },
  { id: "ending", label: "结局解析" },
  { id: "relations", label: "人物关系" },
  { id: "characters", label: "角色介绍" },
  { id: "faq", label: "常见疑问" },
];